export const LK_RECIPIENT_DETAILS = "LK_RECIPIENT_DETAILS";
export const LK_RECIPIENT_DETAILS_SUCCESS = "LK_RECIPIENT_DETAILS_SUCCESS";
export const LK_RECIPIENT_DETAILS_FAIL = "LK_RECIPIENT_DETAILS_FAIL";
export const EDIT_LK_RECIPIENT = "EDIT_LK_RECIPIENT";
export const EDIT_LK_RECIPIENT_SUCCESS = "EDIT_LK_RECIPIENT_SUCCESS";
export const EDIT_LK_RECIPIENT_FAIL = "EDIT_LK_RECIPIENT_FAIL";
export const DELETE_LK_RECIPIENT = "DELETE_LK_RECIPIENT";
export const DELETE_LK_RECIPIENT_SUCCESS = "DELETE_LK_RECIPIENT_SUCCESS";
export const DELETE_LK_RECIPIENT_FAIL = "DELETE_LK_RECIPIENT_FAIL";

export const LK_RECIPIENT_HISTORY = "LK_RECIPIENT_HISTORY";
export const LK_RECIPIENT_HISTORY_SUCCESS = "LK_RECIPIENT_HISTORY_SUCCESS";
export const LK_RECIPIENT_HISTORY_FAIL = "LK_RECIPIENT_HISTORY_FAIL";
